"use client"
import React, { useRef, useState, useEffect } from "react";
import RatingImg from "~/icons/rating.png"
import './index.css'
import {programs}from'./utils'

const ReferralForm = () => {
  // State Management
  const [step,setStep]=useState(1);
  const [formData, setFormData] = useState({
    fullName: "",
    email: "",
    mobile: "",
    program: {
      ProgramID:0,
      ProgramName: "",
      Specialization: "",
      index: 0,
    }, 
    verificationEmailOrMobile: "",
    otp: Array(6).fill(""),
  });
  const [newData,setNewData] = useState(
    {
      AmityEmail:"",
      EnrollmentNo:"",
      Name:"",
      PersonalEmail:"",
      Phone:"",
      ProgramName:"",
    }
  )
  const otpRefs = useRef<(HTMLInputElement | null)[]>([]);
  const [showOtpBox, setShowOtpBox] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [isSubmitDisabled,setIsSubmitDisabled]=useState(true);
  const [timer, setTimer] = useState(0);
  const [resendEnabled, setResendEnabled] = useState(false);
  const [isValidationDisabled, setIsValidationDisabled] = useState(true);
  const [isValidationUsed, setIsValidationUsed] = useState(false);

  const [errors, setErrors] = useState({
    fullName:'',
        email:'',
        mobile:'',
        program:'',
        verificationEmailOrMobile:'',
        otp:''
  });

  useEffect(() => {
    const isFormValidForValidation =
      formData.fullName.trim() &&
      formData.email.trim() &&
      formData.mobile.trim() &&
      formData.verificationEmailOrMobile.trim() &&
      !Object.values(errors).some((error) => error);
    
      setIsValidationDisabled(!isFormValidForValidation);
  }, [formData, errors]);

  useEffect(() => {
    const isFormValidForSubmit =
      formData.fullName.trim() &&
      formData.email.trim() &&
      formData.mobile.trim() &&
      formData.verificationEmailOrMobile.trim() &&
      formData.otp.every((digit) => digit) && 
      !Object.values(errors).some((error) => error); 
  
    setIsSubmitDisabled(!isFormValidForSubmit);
  }, [formData, errors]);

  useEffect(() => {
    if (timer > 0) {
      const interval = setInterval(() => setTimer((prev) => prev - 1), 1000);
      return () => clearInterval(interval);
    }else {
      setResendEnabled(true); 
    }
  }, [timer]);

  const handleChange = ({ target: { name, value } }) => {
  setFormData((prev) => ({ ...prev, [name]: value }));
  validate(name, value);
  };

  const resendOTP = () =>{
    setFormData((prev) => ({ ...prev, otp: Array(6).fill("")}));
    setErrors((prev) => ({...prev, otp: "" }));
    fetchOTP()
  }

  const fetchOTP = async () => {
    if (isSubmitting || !resendEnabled) return; 
    setIsValidationDisabled(true);
    setIsValidationUsed(true);

    const isEmail = formData.verificationEmailOrMobile.includes("@") ? true : false;
    try {
      const response = await fetch("/api/referral/referralform/otp", {
        method: "POST",
        headers: {
          'Content-Type': 'application/json',
        },
        body: isEmail ? 
        JSON.stringify({  Email: formData.verificationEmailOrMobile, OTPFor:"Referral"  }) :  
          JSON.stringify({ Phone: formData.verificationEmailOrMobile, OTPFor: "Referral" }),
      });
      const data = await response.json();
      const res=await data.response
      setNewData(res)

      if (res.Status === "Sent") {

        localStorage.setItem('otpData', JSON.stringify({ otp: data, timestamp: Date.now() }));
        setShowOtpBox(true);
        setTimer(180); 
        setResendEnabled(false);
        setErrors((prev) => ({ ...prev, otp: "" }));
        setIsValidationDisabled(false);
      } else if (res.Status === "NotSent") {

        setErrors((prev) => ({
          ...prev,
          verificationEmailOrMobile: "Your email/phone is not registered.",
        }))};
    }catch (error) {
      console.error("Error fetching OTP:", error);
    } finally {
      setIsSubmitting(false); 
      setIsValidationUsed(false);
    }  
  };

  const handleOtpChange = (index, value) => {
    if (!/\d/.test(value) && value !== "") return;
    setFormData((prev) => {
      const newOtp = [...prev.otp];
      newOtp[index] = value;
      return { ...prev, otp: newOtp };
    });

    setErrors((prev) => ({ ...prev, otp: "" }));

    if (value && index < formData.otp.length - 1) {
      otpRefs.current[index + 1]?.focus();
    }
  };

  const otpRef = (el, index) => {
    otpRefs.current[index] = el;
  };

  
  const handleOtpKeyDown = (index, e) => {
    const isArrowLeft = e.key === "ArrowLeft";
    const isArrowRight = e.key === "ArrowRight";
    const isBackspace = e.key === "Backspace";
  
    if (isArrowLeft || isArrowRight) {
      const moveToIndex = isArrowLeft ? index - 1 : index + 1;
      if (moveToIndex >= 0 && moveToIndex < formData.otp.length) {
        const targetInput = document.getElementById(`otp-input-${moveToIndex}`);
        if (targetInput) {
          e.preventDefault();
          targetInput.focus();
        }
      }
    } else if (isBackspace && !formData.otp[index]) {
      // Move focus to the previous input if the current one is empty
      const prevIndex = index - 1;
      if (prevIndex >= 0) {
        const prevInput = document.getElementById(`otp-input-${prevIndex}`);
        if (prevInput) {
          e.preventDefault();
          setFormData((prev) => {
            const updatedOtp = [...prev.otp];
            updatedOtp[prevIndex] = "";
            return { ...prev, otp: updatedOtp };
          });
          prevInput.focus();
        }
      }
    }
  }

  const handlePaste = (e, index) => {
    e.preventDefault();
    const pasteData = e.clipboardData.getData('Text');
  
    if (/^\d+$/.test(pasteData)) {
      const updatedOtp = [...formData.otp];
      let lastFilledIndex = index;
  
      for (let i = 0; i < pasteData.length; i++) {
        if (index + i < formData.otp.length) {
          updatedOtp[index + i] = pasteData[i];
          lastFilledIndex = index + i; 
        }
      }
  
      setFormData((prev) => ({ ...prev, otp: updatedOtp }));
      const nextIndex = lastFilledIndex + 1;
      const nextInput = document.getElementById(`otp-input-${nextIndex}`);
      if (nextInput) {
        nextInput.focus();
      } else {
        const lastInput = document.getElementById(`otp-input-${lastFilledIndex}`);
        if (lastInput) lastInput.focus();
      }
    }
  };  


  const validate = (name, value) => {
    const updatedErrors = { ...errors };
  
    switch (name) {
      case "fullName":
        updatedErrors.fullName =
          !value.trim()
            ? "Full Name is required."
            : value.length < 3
            ? "Full Name must be at least 3 characters."
            : /\d/.test(value)
            ? "Full Name should not contain numbers."
            : "";
        break;

      case "email":
        updatedErrors.email =
          !value.trim()
            ? "Email is required."
            : !/^[\w.%+-]+@[\w.-]+\.[a-zA-Z]{2,}$/.test(value)
            ? "Enter a valid email address."
            : "";
        break;

      case "mobile":
        updatedErrors.mobile =
          !value.trim()
            ? "Mobile number is required."
            : !/^\d{10}$/.test(value)
            ? "Enter a valid 10-digit mobile number."
            : "";
        break;

      case "verificationEmailOrMobile":
          updatedErrors.verificationEmailOrMobile =
            !value.trim()
              ? "Verification email or mobile is required."
              : /^[a-zA-Z]/.test(value)
              ? !/^[\w.%+-]+@[\w.-]+\.[a-zA-Z]{2,}$/.test(value)
                ? "Enter a valid email address."
                : ""
              : /^\d/.test(value)
              ? !/^\d{10}$/.test(value)
                ? "Enter a valid 10-digit mobile number."
                : ""
              : "Invalid input. Please enter a valid email or mobile number.";
          break;
      default:
          break;
    }
    setErrors(updatedErrors);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const storedOtpData = JSON.parse(localStorage.getItem('otpData') || '{}');

    if (storedOtpData?.timestamp) {
      const elapsedTime = Math.floor((Date.now() - storedOtpData.timestamp) / 1000);
      if (elapsedTime >= 180) {
        setErrors((prev) => ({ ...prev, otp: 'OTP has expired. Please resend OTP.' }));
        return;
      }
    }

    const enteredOtp = formData.otp.join("");
    if (storedOtpData?.otp.response?.OTP !== Number(enteredOtp)) {
      setErrors((prev) => ({ ...prev, otp: "Incorrect OTP. Please try again." }));
      return;
    }
    
    setIsSubmitting(true);
    setIsSubmitDisabled(true);
    try{
      const url = new URL(window.location.href);
      const searchParams = new URLSearchParams(url.search);

      const response = await fetch("/api/referral/referralform/submit",{
        method: "POST",
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          leadName: formData.fullName,
          leadEmailAddress: formData.email,
          leadPhone: formData.mobile,
          programID: formData.program.ProgramID,
          programName: formData.program.ProgramName,
          specialization: formData.program.Specialization,
          pageUrl: window.location.href,
          referrerEmail: formData.verificationEmailOrMobile,
          utm_source: searchParams.get('utm_source'),
          ReferrerAmityEmail:newData.AmityEmail,
          ReferrerEnrollmentNo:newData.EnrollmentNo,
          ReferrerName:newData.Name,
          ReferrerPersonalEmail:newData.PersonalEmail,
          ReferrerPhone:newData.Phone,
          ReferrerProgramName:newData.ProgramName,
        }),
      }); 

      const result = await response.json(); 
      console.log(result,'from api response')

      if (result.response.body.status === "Lead already exists") {
        setErrors((prev) => ({ ...prev, otp: "Lead already exists." }));
      } else {
        console.log("Form submission successful.");
        setStep(2);
      }
    } catch (error) {
      console.error("Error submitting the form:", error);
      setErrors((prev) => ({ ...prev, form: "An error occurred. Please try again." }));
    } finally {
      setIsSubmitting(false);
    }

  };


  return (
    <div className={ `bg-white shadow-lg rounded-2xl p-4 md:p-5 border  border-[#1a325d] right`}>
      {step==1 && (
        <>
         <div 
         className="text-center text-[#1a325d] mb-4 mt-10 banner-form-title">
    Share details of the interested candidate who wants to pursue an Online Degree
  </div>
    <form className="form_handle" onSubmit={handleSubmit}>
      <div className="space-y-2">
        <div style={{position:'relative'}}>
          <input
            type="text"
            name="fullName"
            placeholder="Full Name*"
            value={formData.fullName}
            onChange={handleChange}
            className={`w-full border h-7 rounded pl-2 mb-2 text-sm bg-white ${
              errors.fullName ? "border-red-500" : "border-gray-300"}
            }`}
          />
          {errors.fullName && (
            <p className="absolute text-red-500 left-0 error-msg">
            {errors.fullName}
          </p>
          )}
        </div>

        <div style={{position:'relative',}}>
          <input
            type="email"
            name="email"
            placeholder="Email*"
            value={formData.email}
            onChange={handleChange}
            className={`w-full border h-7 rounded pl-2 input_div mb-2 text-sm bg-white ${
              errors.email ? "border-red-500" : "border-gray-300"
            }`}
          />
          {errors.email && (
            <p className="absolute text-red-500 left-0 error-msg">{errors.email}</p>
          )}
        </div>

        <div style={{position:'relative'}}>
          <input
            type="text"
            name="mobile"
            placeholder="Mobile No.*"
            value={formData.mobile}
            onChange={handleChange}
            className={`w-full border h-7 rounded pl-2 text-sm mb-2 bg-white ${
              errors.mobile ? "border-red-500" : "border-gray-300"
            }`}
          />
          {errors.mobile && (
            <p className="absolute text-red-500 left-0 error-msg">{errors.mobile}</p>
          )}
        </div>

        <div style={{position:'relative',marginBottom:'.5rem'}}>
        <select
        className="p-1.5 rounded"
        name="referredCourse"
        value={formData.program.index || 0}
        onChange={(e) => {
          const selectedValue = parseInt(e.target.value);
          
          // If value is 0, reset to initial state
          if (selectedValue === 0) {
            setFormData((prevData) => ({
              ...prevData,
              program: {
                ProgramID: 0,
                ProgramName: "",
                Specialization: "",
                index: 0,
              },
            }));
          } else {
            const selectedProgram = programs.find(
              (program) => program.index === selectedValue
            );
            setFormData((prevData) => ({
              ...prevData,
              program: selectedProgram || null,
            }));
          }
        }}
      
        >
          <option value={0}>Select course</option>
          {programs.map((program) => (
        <option key={program.index} value={program.index}>
        {program.ProgramName}
      </option>
      ))}
        </select>
        </div>
      </div>
      <hr  /> 
      <div className="mt-2" style={{position:'relative'}}>
        <label className="block font-medium text-[#666] mb-2 text-sm">
          Verify Your Details Here
        </label>
        <div>
          <div className="space-y-3">
           {!showOtpBox?(<><div className="flex items-center ">
              <input
                type="text"
                name="verificationEmailOrMobile"
                placeholder="Your email ID / Mobile No."
                value={formData.verificationEmailOrMobile}
                onChange={handleChange}
                className={`w-full border h-7 rounded-l pl-2 mb-2 text-sm bg-white ${
                  errors.verificationEmailOrMobile
                    ? "border-red-500"
                    : "border-gray-300"
                }`}
              />
              <button
                type="button"
                className={`bg-[#1a325d] text-white h-7 p-1 rounded-r mb-2 cursor-pointer text-sm ${
                  isValidationDisabled ? "opacity-50 cursor-not-allowed" : ""
                }`}
                onClick={fetchOTP}
                disabled={isValidationDisabled}
              >              
                {isValidationUsed?'Validating...':'Validate'}
              </button>
            </div>
            {errors.verificationEmailOrMobile && (
              <p className="absolute text-red-500 left-0 error-msg">
                {errors.verificationEmailOrMobile}
              </p>
            )}</>):(<>
            <div>
              <p className="text-xs text-[#666] font-medium">Enter OTP</p>
            </div>
            <div className="grid grid-cols-6 gap-2">
                {formData.otp.map((digit, index) => (
                  <input
                    id={`otp-input-${index}`}
                    key={index}
                    type="text"
                    maxLength={1}
                    value={digit}
                    ref={(el) => otpRef(el,index)}
                    onChange={(e) => handleOtpChange(index, e.target.value)}
                    onKeyDown={(e) => handleOtpKeyDown(index, e)}
                    className={`border rounded p-1 text-sm text-center h-6 bg-white border-gray-300`}
                    onPaste={(e)=>handlePaste(e,index)}
                  />
                ))}
              </div>
              {errors.otp && <p className=" text-red-500 left-0 error_msg">{errors.otp}</p>}
              {resendEnabled ? (
              <a href="#" onClick={resendOTP} className="underline text-[#1a325d] text-xs decoration-1">
                Resend OTP
              </a>
              ) : (
                <p className="text-xs text-gray-500">
                  Resend OTP in {Math.floor(timer / 60)}:{timer % 60 < 10 ? `0${timer % 60}` : timer % 60}
                </p>
              )}
              </>)}
          </div>
        </div>
      </div>
      <div className="mt-6">
        <button
          type="submit"
          className={`w-full h-8 font-semibold text-md rounded-full  ${
            isSubmitDisabled
              ? "bg-[#EBEBE4] text-gray-700 border border-[#1a325d] cursor-not-allowed"
              : "bg-[#ffc907] text-[#1A325D] border border-[#1a325d] cursor-pointer"
          }`}
          disabled={isSubmitDisabled}
        >
          {isSubmitting ? <div className="w-6 h-6 border-4 m-auto border-white border-t-transparent rounded-full animate-spin"></div> : <span style={{fontSize:'0.8rem'}}>SUBMIT</span>}
        </button>
      </div>
    </form>
        </>
      )}
      {step==2 && (
        <div className="flex flex-col items-center text-center p-6">
        <div className="mb-6">
          <img src={RatingImg.src} alt="Rating" className="w-24" />
        </div>
        <h5 className="text-[#1A325D] font-serif text-2xl">
          Thank you for sharing details.
        </h5>
        <p className="text-gray-700 mt-4">
          We will inform you if your reference gets admission in Amity Online and
          also share your reward.
        </p>
        <a
          href="/referral"
          className="mt-6 px-3 py-1 border border-[#1a325d] text-[#1a325d] rounded-3xl transition uppercase font-semibold ">
          Refer More!
        </a>
      </div>
      )}
    </div>
  );
};

export default ReferralForm;
